import * as RadixDropdown from '@radix-ui/react-dropdown-menu';
import { cx } from 'class-variance-authority';
import { forwardRef } from 'react';

const Group = forwardRef<HTMLDivElement, RadixDropdown.DropdownMenuGroupProps>(({ className, ...props }, ref) => {
  return <RadixDropdown.Group className={cx('p-1', className)} {...props} ref={ref} />;
});

export default Group;
